import { createApp } from 'vue'
import App from './App.vue'
import { registerPlugins } from '@/plugins'
import './styles/tailwind.css'
import './styles/custom.css'

const app = createApp(App)

registerPlugins(app)

app.mount('#app')
